"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexContainer = void 0;
var react_1 = __importDefault(require("react"));
;
var FlexContainer = function (_a) {
    var children = _a.children, _b = _a.direction, direction = _b === void 0 ? "row" : _b, _c = _a.grow, grow = _c === void 0 ? 0 : _c, _d = _a.padding, padding = _d === void 0 ? "15px" : _d, customClasses = _a.customClasses;
    return (react_1.default.createElement("div", { style: { padding: padding }, className: "axxes-flex-container " + (direction === "column" ? "--dir-col" : "--dir-row") + " " + (grow === 1 ? "--grow" : "") + " " + (customClasses !== null && customClasses !== void 0 ? customClasses : "") }, children));
};
exports.FlexContainer = FlexContainer;
